import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-auth-tools',
  templateUrl: './auth-tools.component.html',
  styleUrls: ['./auth-tools.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthToolsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/developer/auth-tools/auth-tools.component.ts